import { render, staticRenderFns } from "./RevenueView.vue?vue&type=template&id=56f2a35f&scoped=true"
import script from "./RevenueView.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RevenueView.vue?vue&type=style&index=0&id=56f2a35f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f2a35f",
  null
  
)

export default component.exports